import builder from '../builder';
import SocialVideoYoutube from '../../streamline-icons/light/social-video-youtube.svg';
export default builder('IconSocialVideoYoutubeLight', SocialVideoYoutube);
//# sourceMappingURL=SocialVideoYoutube.js.map